import { AfterViewInit, ChangeDetectionStrategy, Component, HostListener, Inject, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatButton } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle
} from '@angular/material/dialog';

@Component({
  selector: 'bt-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MatButton,
    MatDialogActions,
    MatDialogClose,
    MatDialogContent,
    MatDialogTitle
  ]
})
export class ConfirmDialogComponent implements AfterViewInit {
  @ViewChild('okayBtn') okayButton: MatButton;
  title: string;
  text: string;
  showCancelButton = true;
  okButtonText = 'OK';
  cancelButtonText = 'Cancel';
  confirmOnEnter = false;
  result = false; // Enter key can set result to true so keydown event will close dialog with approval

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ConfirmDialogComponent>
  ) {
    this.text = data.text;
    this.confirmOnEnter = data.confirmOnEnter;
    this.title = data.title;
    if (data.okButtonText) {
      this.okButtonText = data.okButtonText;
    }
    if (data.cancelButtonText) {
      this.cancelButtonText = data.cancelButtonText;
    }
    this.showCancelButton = data.showCancel;
  }

  ngAfterViewInit(): void {
    if (this.confirmOnEnter) {
      this.okayButton.focus();
    }
  }

  @HostListener('window:keydown.enter')
  onDialogClick(): void {
    if (this.confirmOnEnter) {
      this.okay();
    }
    else {
      this.dialogRef.close(false);
    }
  }

  okay() {
    this.result = true;
    this.dialogRef.close(true);
  }
}
